export default __webpack_public_path__ + "static/media/pdf_logo.7d8c7d9e.png";